import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=47501201&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=ts&"
export * from "./Summary.vue?vue&type=script&lang=ts&"
import style0 from "./Summary.vue?vue&type=style&index=0&id=47501201&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47501201",
  null
  
)

export default component.exports